__turbopack_context__.v({
  "centered": "BXe9xG_centered",
  "container": "BXe9xG_container",
  "content": "BXe9xG_content",
  "desktopOnly": "BXe9xG_desktopOnly",
  "memberDetail": "BXe9xG_memberDetail",
  "memberDetail__container": "BXe9xG_memberDetail__container",
  "memberDetail__irlContribution": "BXe9xG_memberDetail__irlContribution",
  "singleColumn": "BXe9xG_singleColumn",
});
